import { API_BASE } from "./util";

export interface PositionSummary {
  id: string;
  name: string;
  description?: string;
}

export interface CreatePositionResponse {
  id: string;
}

export async function getPositions(
  getToken: () => Promise<string | null>,
  orgId: string,
): Promise<{ positions: PositionSummary[] }> {
  const token = await getToken();
  const res = await fetch(`${API_BASE}/organizations/${orgId}/positions`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) {
    throw new Error(`Failed to fetch positions: ${res.status}`);
  }
  return res.json();
}

export async function createPosition(
  getToken: () => Promise<string | null>,
  orgId: string,
  name: string,
  description?: string,
): Promise<CreatePositionResponse> {
  const token = await getToken();
  const res = await fetch(`${API_BASE}/organizations/${orgId}/positions`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ name, description }),
  });
  if (!res.ok) {
    throw new Error(`Failed to create position: ${res.status}`);
  }
  return res.json();
}
